import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Logo = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ my: 4, textAlign: "center", width: {xs: '130px', sm:'150px'}, height: "auto" }}>
      <img
        onClick={() => navigate("/")}
        style={{ cursor: "pointer",width: '100%', height: 'auto' }}
        src={'/assets/logo.png'}
        alt="logo"
      />
    </Box>
  );
};

export default Logo;
